import React, { memo } from 'react';
import './Styles.css';
import PostalFields from '../CommonFields/PostalFields';
import CareOfFields from '../CommonFields/CareOfFields';
import { formatMessage } from '../../../../Localization/formatMessage';
import Messages from '../../../../Localization/Messages';
import TextInput from '../../../ids/InputElements/TextInput';
import AddressCountrySelector from '../CommonFields/AddressCountrySelector';

const PostBoxAddress = ({ getCommonFields, modalMode, addressState, setAddressState, countryList }) => {
  return (
    <>
      <CareOfFields modalMode={modalMode} addressState={addressState} setAddressState={setAddressState} />

      <TextInput
        cssClasses="formatSwitcher-postBox-input"
        label={formatMessage(Messages.addressInfo_postBoxNumber)}
        {...getCommonFields('number', true)}
      />

      <TextInput
        cssClasses="formatSwitcher-postBox-input"
        label={formatMessage(Messages.addressInfo_postBoxName)}
        {...getCommonFields('facilityName')}
      />

      <AddressCountrySelector addressState={addressState} countryList={countryList} setAddressState={setAddressState} />
      <PostalFields
        key={addressState.address.postalCode}
        getCommonFields={getCommonFields}
        setAddressState={setAddressState}
        addressState={addressState}
      />
    </>
  );
};

export default memo(PostBoxAddress);
